"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildOperation = exports.OperationTypeMap = void 0;
var logs_1 = require("@ledgerhq/logs");
var buildBigNumber_1 = require("../buildBigNumber");
var account_1 = require("../../account");
var libcore_buildOperation_1 = __importDefault(require("../../generated/libcore-buildOperation"));
var env_1 = require("../../env");
exports.OperationTypeMap = {
    "0": "OUT",
    "1": "IN"
};
function buildOperation(arg) {
    return __awaiter(this, void 0, void 0, function () {
        var coreOperation, accountId, currency, contextualSubAccounts, buildOp, operationType, type, coreValue, value, coreFee, fee, blockHeight, _a, recipients, senders, date, _b, partialOp, rest, id, op, OPERATION_ADDRESSES_LIMIT;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    coreOperation = arg.coreOperation, accountId = arg.accountId, currency = arg.currency, contextualSubAccounts = arg.contextualSubAccounts;
                    buildOp = libcore_buildOperation_1["default"][currency.family];
                    if (!buildOp) {
                        throw new Error(currency.family + " family not supported");
                    }
                    return [4 /*yield*/, coreOperation.getOperationType()];
                case 1:
                    operationType = _c.sent();
                    type = exports.OperationTypeMap[operationType] || "NONE";
                    return [4 /*yield*/, coreOperation.getAmount()];
                case 2:
                    coreValue = _c.sent();
                    return [4 /*yield*/, (0, buildBigNumber_1.libcoreAmountToBigNumber)(coreValue)];
                case 3:
                    value = _c.sent();
                    return [4 /*yield*/, coreOperation.getFees()];
                case 4:
                    coreFee = _c.sent();
                    if (!coreFee)
                        throw new Error("fees should not be null");
                    return [4 /*yield*/, (0, buildBigNumber_1.libcoreAmountToBigNumber)(coreFee)];
                case 5:
                    fee = _c.sent();
                    if (type === "OUT") {
                        value = value.plus(fee);
                    }
                    return [4 /*yield*/, coreOperation.getBlockHeight()];
                case 6:
                    blockHeight = _c.sent();
                    return [4 /*yield*/, Promise.all([
                            type === "IN" && currency.family === "bitcoin"
                                ? coreOperation.getSelfRecipients()
                                : coreOperation.getRecipients(),
                            coreOperation.getSenders(),
                        ])];
                case 7:
                    _a = __read.apply(void 0, [_c.sent(), 2]), recipients = _a[0], senders = _a[1];
                    _b = Date.bind;
                    return [4 /*yield*/, coreOperation.getDate()];
                case 8:
                    date = new (_b.apply(Date, [void 0, _c.sent()]))();
                    partialOp = {
                        type: type,
                        value: value,
                        fee: fee,
                        senders: senders,
                        recipients: recipients,
                        blockHeight: blockHeight,
                        blockHash: null,
                        accountId: accountId,
                        date: date,
                        extra: {}
                    };
                    return [4 /*yield*/, buildOp(arg, partialOp)];
                case 9:
                    rest = _c.sent();
                    if (!rest)
                        return [2 /*return*/, null];
                    id = "".concat(accountId, "-").concat(rest.hash, "-").concat(rest.type || type).concat(rest.extra && rest.extra.id ? "-" + rest.extra.id : "");
                    op = __assign(__assign({ id: id, subOperations: contextualSubAccounts
                            ? (0, account_1.inferSubOperations)(rest.hash, contextualSubAccounts)
                            : undefined }, partialOp), rest);
                    OPERATION_ADDRESSES_LIMIT = (0, env_1.getEnv)("OPERATION_ADDRESSES_LIMIT");
                    if (op.recipients.length > OPERATION_ADDRESSES_LIMIT) {
                        (0, logs_1.log)("warning", "operation.recipients too big (".concat(op.recipients.length, " > ").concat(OPERATION_ADDRESSES_LIMIT, ") \u2013 ").concat(id));
                        op.recipients.splice(OPERATION_ADDRESSES_LIMIT);
                    }
                    if (op.senders.length > OPERATION_ADDRESSES_LIMIT) {
                        (0, logs_1.log)("warning", "operation.senders too big (".concat(op.senders.length, " > ").concat(OPERATION_ADDRESSES_LIMIT, ") \u2013 ").concat(id));
                        op.senders.splice(OPERATION_ADDRESSES_LIMIT);
                    }
                    return [2 /*return*/, op];
            }
        });
    });
}
exports.buildOperation = buildOperation;
//# sourceMappingURL=buildOperation.js.map